<template>
    <el-card class='card_warp'>
        <el-form ref="addPart" label-width="140px">
            <el-form-item label="选择模板：" prop='Title'
                class="is-required">
                <el-select size="small"
                v-model="form.templateId" 
                placeholder="请选择"
                value-key="templateId"
                @change="changeTemplate">
                    <el-option
                    v-for="item in templateList"
                    :key="item.templateId"
                    :label="item.templateName"
                    :value="item.templateId">
                    </el-option>
                </el-select>
            </el-form-item>

            <div v-for="item in template.filedList"
                :key="item.enField">
                <el-form-item :label='item.chField + "："' prop='Url'
                class="is-required">
                    <el-date-picker
                        v-model="item.fieldContent"
                        type="datetime"
                        size='small'
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间"
                        v-if="item.enField.startsWith('time')">
                        </el-date-picker>

                    <el-input type="text"
                        placeholder='最多20个字符，超出会推送失败'
                        size='small'
                        maxlength="20"
                        v-model.trim='item.fieldContent'
                        class='width_short'
                        v-else></el-input>

                </el-form-item>
            </div>
            
            <el-form-item label="推送时间：" prop='Title'
                class="is-required">
                <el-date-picker
                v-model="form.pushTime"
                type="datetime"
                size='small'
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label='跳转链接：' prop='Url'
                class="is-required">
                <el-input type="text" placeholder='请输入链接' size='small'
                    v-model.trim='form.jumpUrl'
                    class='width_short'></el-input>
            </el-form-item>
            <el-form-item v-if="PAGEKEY !== 'service_push_look'">
                <el-button type='info' size='small' @click='closePage'>取 消</el-button>
                <el-button type='primary' size='small' @click='save'
                :loading="singleSubmit">确 认</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>
<script scoped>
import pageRouter from "@/utils/pageRouter"
import requestApi from '@/api/operateManage/servicePush'
export default {
    name: 'service_push_page',
    props: {
        PAGEKEY: {
            type: String,
            default: () => ''
        },
        PAGEBACK: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            id: '',
            form: {
                templateId: '',
                templateName: '',
                filedList: [],
                pushTime: '',
                jumpUrl: '',
            },
            template: {},
            templateList: [],
            singleSubmit: false,
        }
    },
    activated() {
        if (this.$route.params.id === this.id) {
            return
        }
        this.id = this.$route.params.id
        if(this.id) {
            this.get()
        } else {
            this.getTemplate()
        }
        
    },
    methods: {
        async getTemplate() {
            await requestApi.getWxTempLateList().then(res => {
                if(res.Success) {
                    this.templateList = res.Data
                } else {
                    this.$message.error(res.Message)
                }
            })
        },
        changeTemplate(item) {
            this.template = this.templateList.find(
                i => i.templateId === item)
        },
        // 获取数据
        async get() {
            await this.getTemplate()
            await requestApi.getDetail({
                id: this.id
            }).then(res => {
                if(res.Success) {
                    this.form = res.Data
                } else {
                    this.$message.error(res.Message)
                }
            })
            this.template = this.form
            for(let item of this.templateList) {
                if(item.templateId === this.form.templateId) {
                    this.templateList.filedList = this.form.filedList
                    break
                }
            }
        },
        // 保存
        save() {
            this.form = Object.assign(this.form, this.template)
            for(let item in this.form) {
                if(!this.form[item]) {
                    this.$message.error('有内容未填写')
                    return
                }
            }
            for(let item of this.form.filedList) {
                if(!item.fieldContent) {
                    this.$message.error('有内容未填写')
                    return
                }
            }
            this.singleSubmit = true
            requestApi.save(this.form).then(res => {
                if(res.Success) {
                    this.$message.success('保存成功')
                    this.closePage()
                } else {
                    this.$message.error(res.Message)
                }
            }).finally(() => {
                this.singleSubmit = false
            })
        },
        // 关闭tab
        closePage() {
            this.$store.dispatch("tabs/removeSpecifiedTab", this.PAGEKEY)
            this.$store.dispatch("tabs/toTargetTab", this.PAGEBACK)
        }
    }
}
</script>
<style type="text/less" lang="less" scoped>
.card_warp{
    width: 600px;
    padding-top: 10px; 
    padding-bottom: 10px; 
}
.click_word{
    color: #409EFF;
    cursor: pointer;
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/views/operateManage/service_push/components/page.vue